export default {
  state: {
    unavailableExam: false,
    absenceModal: false,
    preparationModal: false
  },

  getters: {
    unavailableExam: (state) => {
      return state.unavailableExam
    },
    absenceModal: (state) => {
      return state.absenceModal
    },
    preparationModal: (state) => {
      return state.preparationModal
    }
  },

  mutations: {
    toggleUnavailableExam (state) {
      state.unavailableExam = !state.unavailableExam
    },
    toggleAbsenceModal (state) {
      state.absenceModal = !state.absenceModal
    },
    togglePreparationModal (state) {
      state.preparationModal = !state.preparationModal
    }
  },

  actions: {
    toggleModal ({ commit }, payload) {
      switch (payload) {
        case 'unavailableExam':
          commit('toggleUnavailableExam')
          break
        case 'absenceModal':
          commit('toggleAbsenceModal')
          break
        case 'preparationModal':
          commit('togglePreparationModal')
      }
    }
  }
}
